import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新增");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("查看");

import { onMounted, ref } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getRecruitBannerList, recruitBannerUpdateStatus, deleteRecruitBanner, getRecruitNoticeList } from '@/request';
import { getVexTableProps } from '@/config';
import RecruitBannerModal from './component/RecruitBannerModal.vue';
export default {
  name: 'RecruitBannerList',

  setup(__props) {
    const table = ref();
    const showModal = ref(false);
    const editData = ref(null);
    const isSee = ref(false);
    const noticeOptions = ref([]);
    const statusMap = {
      1: '启用',
      2: '禁用'
    };
    const tableOptions = getVexTableProps({
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        title: '图片',
        width: '100px',
        slots: {
          default: 'previewImg'
        }
      }, {
        field: 'sort',
        title: '排序',
        width: '80px'
      }, {
        field: 'linkRecruitTitle',
        title: '跳转公告',
        minWidth: '180px',
        showOverflow: true
      }, {
        field: 'status',
        title: '状态',
        width: '90px',

        formatter({
          cellValue
        }) {
          return statusMap[cellValue] || '-';
        }

      }, {
        title: '投放时间',
        width: '220px',
        formatter: ({
          row
        }) => `${row.startTime || '-'} 至 ${row.endTime || '-'}`
      }, {
        field: 'createBy',
        title: '创建人',
        width: '120px'
      }, {
        field: 'updateAt',
        title: '更新时间',
        width: '170px'
      }, {
        title: '操作',
        width: '230px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getRecruitBannerList({
              page: page.currentPage,
              pageSize: page.pageSize
            }).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });
    onMounted(() => {
      loadNoticeOptions();
    });

    function loadNoticeOptions() {
      getRecruitNoticeList({
        page: 1,
        pageSize: 200,
        status: 1
      }).then(res => {
        noticeOptions.value = res.data && res.data.list || [];
      });
    }

    function openAdd() {
      editData.value = null;
      isSee.value = false;
      showModal.value = true;
    }

    function openEdit(row) {
      editData.value = _objectSpread({}, row);
      isSee.value = false;
      showModal.value = true;
    }

    function openSee(row) {
      editData.value = _objectSpread({}, row);
      isSee.value = true;
      showModal.value = true;
    }

    function onSuccess() {
      table.value.commitProxy('reload');
    }

    function updateStatus(row, status) {
      const label = statusMap[status];
      ElMessageBox.confirm(`是否确认${label}「${row.linkRecruitTitle || '该 Banner'}」？`, {
        title: label
      }).then(() => {
        recruitBannerUpdateStatus({}, {
          params: {
            status,
            bannerIdList: row.bannerId,
            __repeat: true,
            __warn: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('reload');
          }
        });
      });
    }

    function deleteBanners() {
      const rows = table.value.getCheckboxRecords();

      if (!rows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${rows.length}条数据?`, '删除').then(() => {
        deleteRecruitBanner({}, {
          params: {
            bannerIdList: rows.map(row => row.bannerId).join(','),
            __warn: true,
            __repeat: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: openAdd
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "danger",
          icon: "Delete",
          onClick: deleteBanners
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        previewImg: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.imageUrl,
          "preview-src-list": [row.imageUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: row.status === 1 ? 'danger' : 'success',
          onClick: $event => updateStatus(row, row.status === 1 ? 2 : 1)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.status === 1 ? '禁用' : '启用'), 1)]),
          _: 2
        }, 1032, ["type", "onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => openEdit(row)
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "success",
          onClick: $event => openSee(row)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(RecruitBannerModal, {
        modelValue: showModal.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showModal.value = $event),
        "edit-data": editData.value,
        "is-see": isSee.value,
        "notice-options": noticeOptions.value,
        onSuccess: onSuccess
      }, null, 8, ["modelValue", "edit-data", "is-see", "notice-options"])]);
    };
  }

};